import { render } from "./MiRadio.vue?vue&type=template&id=8f026418&scoped=true"
import script from "./MiRadio.vue?vue&type=script&lang=js"
export * from "./MiRadio.vue?vue&type=script&lang=js"

import "./MiRadio.vue?vue&type=style&index=0&id=8f026418&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f026418"]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
